import { cn } from '@/lib/utils'

type BrandMarkProps = {
  className?: string
  collapsed?: boolean
}

export function BrandMark({ className, collapsed = false }: BrandMarkProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2.5 select-none',
        className,
      )}
    >
      <span
        aria-hidden
        className="relative inline-flex size-7 items-center justify-center rounded-md bg-gradient-to-br from-amber-400 via-orange-500 to-rose-600 text-white shadow-sm shadow-rose-500/30 ring-1 ring-rose-500/30"
      >
        <span className="absolute inset-0 rounded-md bg-gradient-to-br from-white/30 via-transparent to-transparent" />
        <svg
          viewBox="0 0 24 24"
          className="size-4 relative drop-shadow-sm"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.4}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 19h14" />
          <path d="M9 19V8a3 3 0 0 1 6 0v11" />
          <path d="M7 14h10" />
        </svg>
      </span>
      {collapsed ? null : (
        <span className="flex flex-col leading-tight">
          <span className="text-[15px] font-semibold tracking-tight">Litmers</span>
          <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            Agent control
          </span>
        </span>
      )}
    </div>
  )
}
